// extracted by mini-css-extract-plugin
module.exports =  {"textarea":"_93444fe79c--textarea--K7RuB","counter":"_93444fe79c--counter--roeZQ"};